export const tr = {
    'add-creatives': {
        one: 'Kreatif formatı ekleyin: Hedef kitleyi artırmak için {formats}',
        some: 'Kreatif formatları ekleyin: Hedef kitleyi artırmak için {formats}',
        many: 'Kreatif formatları ekleyin: Hedef kitleyi artırmak için {formats}',
        none: 'Kreatif formatları ekleyin: Hedef kitleyi artırmak için {formats}'
    },
    close: 'Kapat',
    title: 'Uygun formatlarda kreatifler ekleyin',
    'title-hint': 'Öneri, grupta tam kapsam olmadığı için gösterilmektedir'
};
